import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCallWindowStore = defineStore('callWindow', () => {
  const isVisible = ref(false)
  const windowState = ref('closed') // state:'closed', 'open', 'minimized'

  function openWindow() {
    windowState.value = 'open'
    isVisible.value = true
  }

  function closeWindow() {
    windowState.value = 'closed'
    isVisible.value = false
  }

  function minimizeWindow() {
    windowState.value = 'minimized'
    isVisible.value = false
  }

  function toggleVisibility() {
    if (windowState.value !== 'closed') {
      isVisible.value = !isVisible.value
    }
  }

  return {
    isVisible,
    windowState,
    openWindow,
    closeWindow,
    minimizeWindow,
    toggleVisibility,
  }
})
